import { ref } from 'vue';
import { httpService } from '../services/httpService';
import { log, error as logError } from '../utils/DebugLogger';

import '../contracts/Perfil_MeuResponse';
import '../contracts/Perfil_MeuInput';

import type { Perfil_MeuInput } from '../contracts/Perfil_MeuInput';
import type { Perfil_DadosRow } from '../contracts/Perfil_DadosRow';

/**
 * Os dados pessoais de quem está logado (chamado New Shoes 2026-0079, F2). A pessoa vem do
 * token no app-api; aqui só se lê e se grava o rascunho. Nome de login, e-mail e idioma
 * continuam no Cognito e não passam por aqui.
 */
const URL_MEU = '/index.php/perfil/meu';
const URL_SALVAR = '/index.php/perfil/meu_salvar';

export function usePerfil() {
  const dados = ref<Perfil_DadosRow | null>(null);
  const email = ref('');
  const faltando = ref<string[]>([]);

  const guardar = (d: { dados?: Perfil_DadosRow; email?: string; faltando?: string[] } | null | undefined): void => {
    dados.value = d?.dados ?? null;
    email.value = d?.email ?? '';
    faltando.value = d?.faltando ?? [];
  };

  const carregar = async (): Promise<void> => {
    try {
      const r = await httpService.get(URL_MEU, { responseContract: 'Perfil_MeuResponse' });
      if (!r.success) throw new Error(r.error || 'Erro ao carregar o perfil');
      guardar(r.dados);
      log('usePerfil', 'carregar', 'faltando', faltando.value.length);
    } catch (e) {
      logError('usePerfil', 'carregar', 'Erro', e);
      throw e;
    }
  };

  const salvar = async (valores: Perfil_MeuInput): Promise<void> => {
    try {
      const r = await httpService.post(URL_SALVAR, valores, { inputContract: 'Perfil_MeuInput', responseContract: 'Perfil_MeuResponse' });
      if (!r.success) throw new Error(r.error || 'Erro ao salvar o perfil');
      guardar(r.dados);
    } catch (e) {
      logError('usePerfil', 'salvar', 'Erro', e);
      throw e;
    }
  };

  return { dados, email, faltando, carregar, salvar };
}
